module.exports = __webpack_public_path__ + "static/media/file_pdf_dark.bbe18b52.svg";